
import Vue, { PropType } from 'vue'

import { IProduct } from 'types/DTO/products'
import { IPharmacy } from 'types/DTO/pharmacies'
import { IInstitution } from 'types/DTO/institutions'
import { IEntityReviewProps } from 'types/DTO/reviews'

export default Vue.extend({
  name: 'RPHReviewForm',
  components: {
    Heading: () => import('~/components/atoms/Heading.vue'),
    RPHButton: () => import('rph/atoms/RPHButton/index.vue'),
    CloseIcon: () => import('~/assets/svg/close-modal.svg?inline'),
    RPHStarRating: () => import('rph/atoms/RPHStarRating/index.vue'),
    TextArea: () => import('~/components/atoms/textarea.vue'),
  },
  props: {
    entity: {
      type: Object as PropType<IEntityReviewProps>,
    },
  },
  data() {
    return {
      rate: '' as Number | String,
      rateError: false,
      comment: '',
      commentError: false,
    }
  },
  computed: {
    disable(): boolean {
      return !this.rate || !this.comment
    },
    success(): string {
      return this.$store.getters['rph-reviews/success']
    },
    rateServerError(): boolean {
      return this.$store.getters['rph-reviews/rateError']
    },
    contentServerError(): boolean {
      return this.$store.getters['rph-reviews/contentError']
    },
    product(): IProduct {
      return this.$store.getters['rph-products/product']
    },
    pharmacy(): IPharmacy {
      return this.$store.getters['rph-pharmacies/pharmacyBySlug']
    },
    institution(): IInstitution {
      return this.$store.getters['rph-institutions/institutionBySlug']
    },
  },
  watch: {
    comment(newVal: string): void {
      this.commentError = !!this.$services.common.validator.isText(newVal)
    },
    success(newVal: boolean) {
      if (newVal) {
        this.$store.commit('rph-reviews/setSuccess', false)
      }
    },
  },
  methods: {
    toggleModal(): void {
      this.$store.dispatch('rph-modals/clearModals')
    },
    setRate(rate: number): void {
      this.rate = rate
    },
    async sendFeedback() {
      const slug = this.$route.params[this.entity.type]
      // @ts-ignore
      const user = this.$auth.user
      await this.$store.dispatch('rph-reviews/setReview', {
        slug,
        params: {
          text: this.comment,
          stars: +this.rate,
          object: this.entity.type,
          object_id: this.entity.id,
          name: user.name,
          email: user.email,
        },
        // params {
        //   rate: +this.rate,
        //   content: this.comment,
        // }
      })
      this.toggleModal()
    },
  },
})
